import zod from "zod";

export const meSchema = zod.object({
  id: zod.number(),
  email: zod.string().email(),
  ephemeral_token: zod.string().optional(),
});

export type MeResponse = zod.infer<typeof meSchema>;

export const magicLinkSchema = zod.object({
  confirmation_id: zod.string(),
  email: zod.string().email(),
  secret: zod.string(),
});

export type MagicLinkResponse = zod.infer<typeof magicLinkSchema>;

export const confirmSchema = zod.object({
  token: zod.string(),
});

export type ConfirmResponse = zod.infer<typeof confirmSchema>;
